import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { BaseModal } from "../../components/Modal/BaseModal";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RootState } from "../../store";
import { useEffect, useState } from "react";
import { updateJDOpsProductMapping } from "../../slices/productcostseeds.slice";
import { useAddCost } from "../../hooks/useAddCost";

interface Props {
  open: boolean;
  handleClose: () => void;
  product: any;
  isEdit: boolean;
}

export const ProductMappingModal = ({ open, handleClose, product, isEdit }: Props) => {
  const dispatch = useAppDispatch();
  const { handleAddJdOpsProduct } = useAddCost();
  const { productNames } = useAppSelector(
    (state: RootState) => state.seedsdropdown
  );
  const [jdOpsProductName, setJdOpsProductName] = useState("");
  const [selectedProductId, setSelectedProductId] = useState<number | "">("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (isEdit) {
      const prod = productNames.find((pr) => pr.id === product?.productId);
      if (prod) {
        setSelectedProductId(prod.id);
      } else {
        setSelectedProductId("");
      }
      setJdOpsProductName(product?.jdOpsProductName ?? "");
      setNotes(product?.notes ?? "");
    } else {
      setSelectedProductId("");
      setJdOpsProductName("");
      setNotes("");
    }
  }, [isEdit, product, productNames]);

  const handleProductChange = (event: any) => {
    setSelectedProductId(Number(event.target.value));
  };

  const handleSave = async () => {
    if (!selectedProductId) return;

    const requestData = 
      {
        jdOpsProductName: jdOpsProductName,
        productId: selectedProductId,
        notes: notes,
      };
    if (isEdit) {
          await dispatch(
            updateJDOpsProductMapping({ ...requestData, id: product.id })
          );
          handleClose();
        } else {
          const isSuccess = await handleAddJdOpsProduct(requestData);
          if (isSuccess) {
            handleClose();
          }
        }
  };

  return (
    <BaseModal open={open} handleClose={handleClose}>
      <Box display={"flex"} flexDirection={"column"} gap={5}>
        <Typography variant="h6">{isEdit ? "Edit Product Mapping" : "Add Product Mapping"}</Typography>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <TextField
            label="Linked JD Ops Product"
            variant="outlined"
            value={jdOpsProductName}
            onChange={(event: any) => setJdOpsProductName(event.target.value)}
            InputProps={{
              readOnly: isEdit,
            }}
          />
          <FormControl>
            <InputLabel>Product</InputLabel>
            <Select
              value={selectedProductId}
              label="Product"
              onChange={handleProductChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    overflow: "auto",
                  },
                },
              }}
            >
              {productNames.map((product) => (
                <MenuItem key={product.id} value={product.id}>
                  {product.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Notes"
            variant="outlined"
            onChange={(event: any) => setNotes(event.target.value)}
            value={notes}
          />
        </Box>
        <Box display={"flex"} justifyContent={"flex-end"} gap={2}>
          <Button
            variant="contained"
            color="primary"
            disabled={!selectedProductId}
            onClick={handleSave}
          >
            Save
          </Button>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </BaseModal>
  );
};
